import router from "@/router/Router";
const logout = () => {
  const dark = localStorage.getItem("dark");
  localStorage.removeItem("token");
  localStorage.removeItem("user_data");
  localStorage.removeItem("level");
  localStorage.setItem("auth", "false");
  localStorage.setItem("dark", dark);
  router.push("/auth/login/" + localStorage.getItem("operator"));
};
export default logout;
